import React from "react";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import {green, red, yellow} from "@mui/material/colors";
import {PsychometricParameterTypePsychometricRecommendationEnum} from '../../gen/api';
import GridPaper from "../ContentBox/GridPaper";

type Props = {
  psychometricRecommendation: PsychometricParameterTypePsychometricRecommendationEnum | undefined
  type: string
  onChange?: (recommendation: PsychometricParameterTypePsychometricRecommendationEnum) => any
}

export default function PsychometricParameterRecommendation({
                                                              psychometricRecommendation,
                                                              type,
                                                              onChange
                                                            }: Props) {
  const getControlProps = (recommendation: PsychometricParameterTypePsychometricRecommendationEnum) => ({
    checked: psychometricRecommendation === recommendation,
    value: recommendation,
    inputProps: {'aria-label': recommendation},
  });

  return (
      <GridPaper title={`Psychometrische Empfehlung (${type})`} xs={5} md={3} xl={2}
                 sx={{textAlign: 'center'}}>
        <FormControl>
          <RadioGroup aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group">
            <Radio {...getControlProps(PsychometricParameterTypePsychometricRecommendationEnum.Red)}
                   onChange={_ => onChange ? onChange(PsychometricParameterTypePsychometricRecommendationEnum.Red) : {}}
                   sx={{
                     color: red[800],
                     '&.Mui-checked': {color: red[600]},
                     '& .MuiSvgIcon-root': {fontSize: 32}
                   }}/>
            <Radio {...getControlProps(PsychometricParameterTypePsychometricRecommendationEnum.Yellow)}
                   onChange={_ => onChange ? onChange(PsychometricParameterTypePsychometricRecommendationEnum.Yellow) : {}}
                   sx={{
                     color: yellow[800],
                     '&.Mui-checked': {color: yellow[600]},
                     '& .MuiSvgIcon-root': {fontSize: 32}
                   }}/>
            <Radio {...getControlProps(PsychometricParameterTypePsychometricRecommendationEnum.Green)}
                   onChange={_ => onChange ? onChange(PsychometricParameterTypePsychometricRecommendationEnum.Green) : {}}
                   sx={{
                     color: green[800],
                     '&.Mui-checked': {color: green[600]},
                     '& .MuiSvgIcon-root': {fontSize: 32}
                   }}/>
          </RadioGroup>
        </FormControl>
      </GridPaper>
  );
}